import { render, staticRenderFns } from "./SectionBanner.vue?vue&type=template&id=f42e8c04&scoped=true"
import script from "./SectionBanner.vue?vue&type=script&lang=js"
export * from "./SectionBanner.vue?vue&type=script&lang=js"
import style0 from "./SectionBanner.vue?vue&type=style&index=0&id=f42e8c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42e8c04",
  null
  
)

export default component.exports